import script from "./PhotoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoForm.vue?vue&type=script&setup=true&lang=js"

import "./PhotoForm.vue?vue&type=style&index=0&id=dcb76186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcb76186"]])

export default __exports__